<template>
  <div v-if="show">
    <div class="z-50 overflow-x-hidden overflow-y-auto fixed inset-0 top-0 left-0 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-auto my-6 mx-auto max-w-3xl p-6">
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!-- header -->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-xl font-semibold">
              {{ title }}
            </h3>
            <button
              class="p-1 ml-auto bg-transparent border-0 text-black opacity-50 float-right text-2xl leading-none font-semibold outline-none focus:outline-none"
              type="button"
              @click="onCancel"
            >
              <span class="bg-transparent text-black opacity-50 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!-- body -->
          <div class="p-5">
            <div class="crop-container">
              <img ref="image" :src="imageSrc" class="max-w-full" alt="crop preview" />
            </div>
            <p class="text-xs text-gray-500 mt-2">Drag to reposition. The image will be exported as a 900×900 square JPEG.</p>
          </div>
          <!-- footer -->
          <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
            <button
              class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="button"
              @click="onCancel"
            >
              Cancel
            </button>
            <button
              class="bg-blue-700 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="button"
              @click="onSave"
            >
              Crop &amp; Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="opacity-25 fixed inset-0 z-40 bg-black"></div>
  </div>
</template>

<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css';

const EXPORT_SIZE = 900;
const JPEG_QUALITY = 0.85;

export default {
  name: 'ImageCropModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    imageSrc: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Crop Album Cover',
    },
  },
  data() {
    return {};
  },
  created() {
    this.cropper = null;
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(this.initCropper);
      } else {
        this.destroyCropper();
      }
    },
    imageSrc(val) {
      if (val && this.cropper) {
        this.cropper.replace(val);
      }
    },
  },
  beforeDestroy() {
    this.destroyCropper();
  },
  methods: {
    initCropper() {
      this.destroyCropper();
      if (!this.imageSrc || !this.$refs.image) {
        return;
      }
      this.cropper = new Cropper(this.$refs.image, {
        aspectRatio: 1,
        viewMode: 1,
        autoCropArea: 0.9,
        background: false,
        responsive: true,
        restore: false,
        movable: true,
        zoomable: true,
        scalable: false,
        rotatable: false,
      });
    },
    destroyCropper() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
    onSave() {
      if (!this.cropper) {
        return;
      }
      const data = this.cropper.getData();
      const canvas = this.cropper.getCroppedCanvas({
        width: EXPORT_SIZE,
        height: EXPORT_SIZE,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      });
      if (!canvas) {
        return;
      }
      canvas.toBlob((blob) => {
        if (!blob) {
          return;
        }
        const url = URL.createObjectURL(blob);
        this.$emit('cropped', {
          url,
          sourceWidth: Math.round(data.width),
          sourceHeight: Math.round(data.height),
        });
      }, 'image/jpeg', JPEG_QUALITY);
    },
  },
};
</script>

<style scoped>
.crop-container {
  max-height: 60vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/ImageCropModal.vue